import { Module } from 'vuex';

import { RootState, EditableStatus, ListStatus } from '@/store/types';
import Pagination from '@/store/models/pagination';
import { BeforeAfterImagesState } from './types';

import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export const getInitialState = (): BeforeAfterImagesState => ({
  /**
   * List
   */
  status: ListStatus.Loading,
  list: [],
  listPagination: new Pagination(),

  /**
   * Edit
   */
  editableStatus: EditableStatus.Loading,
});

export const state: BeforeAfterImagesState = getInitialState();

const categories: Module<BeforeAfterImagesState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default categories;
